/**
 * API 客戶端配置
 */

import { apiRequest as authenticatedApiRequest } from './apiClient';

// API Base URL - 區分開發與生產環境
export const API_BASE_URL = import.meta.env.DEV
    ? 'http://localhost:8787'
    : 'https://gad-alchemist-api.backtrue.workers.dev';

/**
 * API 請求封裝（使用 JWT 認證）
 */
export async function apiRequest<T>(
    endpoint: string,
    options: RequestInit = {}
): Promise<{ success: boolean; data?: T; error?: string }> {
    try {
        const response = await authenticatedApiRequest(endpoint, options);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('API Error:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error'
        };
    }
}

/**
 * 診斷 API
 */
export const diagnosisApi = {
    getSummary: () => apiRequest('/api/diagnosis/summary'),
    getCriminals: (status = 'PENDING') => apiRequest(`/api/diagnosis/criminals?status=${status}`),
    runDiagnosis: () => apiRequest('/api/diagnosis', { method: 'POST' }),
    updateCriminal: (id: number, decision: string, modifiedText?: string) =>
        apiRequest(`/api/diagnosis/criminals/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ decision, modifiedText }),
        }),
};

/**
 * 抓取 API
 */
export const fetchApi = {
    getAccounts: () => apiRequest('/api/fetch/accounts'),
    getStats: () => apiRequest('/api/fetch/stats'),
    fetchAll: () => apiRequest('/api/fetch', { method: 'POST' }),
    fetchAccount: (customerId: string) => apiRequest(`/api/fetch/${customerId}`, { method: 'POST' }),
};

/**
 * 部署 API
 */
export const deployApi = {
    getHistory: () => apiRequest('/api/deploy/history'),
    deploy: (criminalIds: number[]) =>
        apiRequest('/api/deploy', {
            method: 'POST',
            body: JSON.stringify({ criminalIds }),
        }),
};
